import { addToChainAfter, addToChainBefore, Handler, HasOnError,HasOnSuccess,replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getWarehouses, GetWarehousesApiParameter } from "@insite/client-framework/Services/WarehouseService";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { WarehouseCollectionModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";

type Parameter = GetWarehousesApiParameter & HasOnSuccess<WarehouseCollectionModel> & HasOnError<string>;

type Props = {
    apiParameter: GetWarehousesApiParameter;
    apiResult: WarehouseCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiWarehouseExtended: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;
    const parameter = props.apiParameter as any;
    const isStockAvailable = state.WhiteCap.stockWarehouseStore.isStockAvailable ?? true;
    const productId = state.WhiteCap.stockWarehouseStore.productId;
    if (isStockAvailable && productId) {
        parameter.isStockAvailable = isStockAvailable;
        parameter.productId = productId;
    }
   
};

addToChainBefore(chain, RequestDataFromApi, RequestDataFromApiWarehouseExtended);
